import { NO_STATE_SELECTION } from 'src/contacts/components/AddressForm/constants'
import { formatCountriesAndRegions } from 'src/helpers/formatCountriesAndRegions'
import { useMemo } from '.'
import { useDetailedCountries } from 'src/react_query'

const useCountryAndRegions = (country: string) => {
  const { data } = useDetailedCountries({ suspense: true })
  const detailedCountries = data!
  const { countries, regions, isRegionsUnavailable } = detailedCountries
    ? formatCountriesAndRegions(detailedCountries, country)
    : { countries: [], regions: undefined, isRegionsUnavailable: false }

  const generatedStateOptions = useMemo(() => {
    return (
      regions ? [NO_STATE_SELECTION, ...regions] : [NO_STATE_SELECTION]
    ).map(region => {
      return {
        value: region,
        label: region,
      }
    })
  }, [regions])

  const generatedCountryOptions = useMemo(() => {
    return (countries || ['United States']).map(country => ({
      value: country,
      label: country,
    }))
  }, [countries])

  return {
    countries,
    regions,
    isRegionsUnavailable,
    generatedStateOptions,
    generatedCountryOptions,
  }
}

export default useCountryAndRegions
